export enum DevicesStatusEnum {
    MOVING = 'moving',
    IDLE = 'idle',
    STOPPED = 'stopped',
}
